import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-21v1',
  templateUrl: './21v1.component.html',
})
export class VbList21v1Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
